import React from 'react';
import PropTypes from 'prop-types';

const InputDropDownList = ({ name, list, keyField, displayField, disabled, nullable, nullableItem, onChange, defaultValue}) => {           
    
    //Prep the list.
    let workingList = [];
    
    if (list !== undefined && list != null && list.error === undefined){    
        if (nullable && nullableItem){     
            if (nullableItem[keyField] === null){
                nullableItem[keyField] = "";
            }                       
            workingList.push(nullableItem);
        }       
        workingList = workingList.concat(list);         
    }
    
    let ddOnChange = (event) => {         
        if (onChange) {
            let res = event.target.value;
            if (res == ""){
                res = null;
            }
           // console.log("res", res);       
            onChange(res);
        }
    };

    const displayText = (item) => {
        let text;                                                        
        if (typeof displayField === 'function'){
            text = displayField(item);                                
        }else{
            if (displayField){
                text = item[displayField];                                
            }
        }
        return text;
    }

    if (disabled){
        let currentItem = null;
        for(let i=0; i < workingList.length; i++){
            let item = workingList[i];
            if (item[keyField] == (defaultValue == null ? "" : defaultValue)){
                currentItem = item;
                break;
            }
        }
        let displayName = displayText(currentItem);         
        return (<span>{displayName}</span>)
    }

    return (
        <div>
          <label></label>
            <select name="select"  
                    value={defaultValue == null ? "" : defaultValue} 
                    onChange={ddOnChange}
                    disabled={disabled}>
                        {workingList.map(function(item) { 
                            let displayName = displayText(item);                                                       
                            return (<option key={item[keyField]} value={item[keyField]}>{displayName}</option>);
                        })}
            </select>
        </div>        
      );
};

InputDropDownList.propTypes = {
    name: PropTypes.string,
    list: PropTypes.oneOfType([PropTypes.array,  PropTypes.oneOf([null]), PropTypes.object]),
    keyField : PropTypes.string,
    displayField : PropTypes.oneOfType([PropTypes.string, PropTypes.func]),    
    disabled : PropTypes.bool,
    nullable : PropTypes.bool,
    nullableItem : PropTypes.any,
    onChange : PropTypes.func,
    defaultValue : PropTypes.any
};




export default InputDropDownList;
